import qs from 'qs'
import { webStorage } from 'utils'

export default (originURL, flyerId) => {
  if (!originURL || !flyerId) {
    const shareQueryParams = {
      language: webStorage.getItem('language'),
      propertyId: webStorage.getItem('propertyId'),
    }
    return `${window.location.href}?${qs.stringify(shareQueryParams)}`
  }
  const parsedURL = new URL(originURL)
  const originQueryParams = qs.parse(parsedURL.query)
  const shareQueryParams = { ...originQueryParams, sf_flyer_id: flyerId, sf_section: 'flyer' }
  return `${parsedURL.protocol}//${parsedURL.host}${parsedURL.pathname}?${qs.stringify(shareQueryParams)}`
}
